document.addEventListener("DOMContentLoaded", function(event) {

    const cart_items = document.querySelectorAll('tr.cart__row');
    const active_bundles = [];
    
    [].forEach.call(cart_items, function(cart_item){
        let bundle_size = cart_item.getAttribute('data-bundle-size');
        let bundle_type = cart_item.getAttribute('data-bundle-type');       
        let cart_item_price = cart_item.getAttribute('data-line-item-price');
        let cart_id = cart_item.getAttribute('data-cart-item-id');
        let cart_quantity = cart_item.getAttribute('data-cart-item-quantity');
        let title = cart_item.getAttribute('data-cart-item-title');
        
        bundle_type != null && bundle_size != null && cart_id != null ?
        group_cart_items(cart_item, bundle_type, bundle_size, cart_item_price, cart_id, cart_quantity, title) : null
    });

    function group_cart_items(cart_item, type, size, price, cart_id, cart_quantity, title) {
        
        cart_item.classList.add('hide');

            active_bundles.push({ 
                "type": type,
                "size": size ,
                "price": price,
                "cart_id": cart_id,
                "quantity": cart_quantity,
                "title": title
            });
    }


    var speciality = {"type": "speciality", "size": 0, "price": 0, "cart_ids": [], "cart_items": []};
    var bottles ={"type": "bottles", "size": 0, "price": 0, "cart_ids": [], "cart_items": []};
    var cans = {"type": "cans", "size": 0, "price": 0, "cart_ids": [], "cart_items": []};

    active_bundles.map(function(bundle){
        if(bundle.type == 'bottles' ){
            bottles.price += parseFloat(bundle.price) 
            bottles.size = bundle.size 
            bottles.cart_ids += `updates[${bundle.cart_id}]=0&`
            bottles.cart_items.push({"title": bundle.title, "quantity": bundle.quantity})
        }else if(bundle.type == 'speciality') {
            speciality.price += parseFloat(bundle.price) 
            speciality.size = bundle.size 
            speciality.cart_ids += `updates[${bundle.cart_id}]=0&`
            speciality.cart_items.push({"title": bundle.title, "quantity": bundle.quantity})
        }else if(bundle.type == 'cans') {
            cans.price += parseFloat(bundle.price) 
            cans.size = bundle.size 
            cans.cart_ids += `updates[${bundle.cart_id}]=0&`
            cans.cart_items.push({"title": bundle.title, "quantity": bundle.quantity})
        }
    })

    bottles.price > 0 ? addToCart(bottles) : null
    speciality.price > 0 ? addToCart(speciality) : null
    cans.price > 0 ? addToCart(cans) : null

    console.log(cans);

    $('.remove').click(function(){
        var bundle_type = $(this).attr('remove-bundle');
        var bundle_to_remove=null;
        bundle_type == 'bottles' ? bundle_to_remove = bottles.cart_ids :
        bundle_type == 'speciality' ? bundle_to_remove = speciality.cart_ids : 
        bundle_type == 'cans' ? bundle_to_remove = cans.cart_ids : null
        
        jQuery.post('/cart/update.js',
            bundle_to_remove
        );

        setInterval(() => {
            location.reload();
        }, 1500);
    });

    $('p.cart__remove a').click(function(){
        location.reload();
    });
    
function addToCart(bundle){
    let bundle_items='';
    bundle.type == 'cans' ? getItems(cans) : null
    bundle.type == 'bottles' ? getItems(bottles) : null
    bundle.type == 'speciality' ? getItems(speciality) : null
    console.log(bundle.type);
    

    function getItems(bundle) {
        bundle.cart_items.map(function(bundle_item){
            bundle_items += `<li>${bundle_item.quantity} x ${bundle_item.title}</li>`;
        });
    }
            $('table tbody').append(`
            <tr class="cart__row">
                <td class="cart__meta small--text-left">
                    <div class="cart__product-information">
                        <div class="cart__image-wrapper">
                            <div class="bundle-image ${bundle.type}"></div>
                        </div>
                        <div class="flex" style="width: max-content;">
                            <span class="sentence"><b>${bundle.type} Bundle</b></span>
                            <details>
                            <summary>Bundle Items</summary>
                            <ul>
                                ${bundle_items}
                            </ul>
                            </details>
                        </div>
                    </div>
                    <td class="desktop-only"></td>
                    <td class="desktop-only"></td>
                </td>
                <td class="cart__price text-right"><span data-cart-item-regular-price>$${bundle.price.toFixed(2)}</span>
                <div class="remove" remove-bundle="${bundle.type}"><p><a>Remove</a></p></div>
                </td>
            </tr>
        `);
}

});